<template>
  <div
    class="flex items-center w-full cell-renderer-item"
    :class="[cellBackgroundColor]"
  >
    <!-- 進捗 -->
    <div
      v-if="params.value && params.value.columnKey == 'progress'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <vs-chip
        class="pm-chip-square-radius pm-chip-width__progress-type-disp"
        :color="progressColorCode(getValueMapSafely(params).id)"
      >
        {{ getValueMapSafely(params).value }}
      </vs-chip>
    </div>

    <!-- 進捗時刻 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'progress_at'"
      class="w-full flex items-center pm-ag-grid-inner-cell pm-time"
      :class="[classNameCursorPointer]"
    >
      <span>{{ formattedTimeForProgress(getValueMapSafely(params)) }}</span>
    </div>

    <!-- FL時 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'first_line_at'"
      class="w-full flex items-center pm-ag-grid-inner-cell pm-time"
      :class="[classNameCursorPointer]"
    >
      <span>{{ formattedTimeForProgress(getValueMapSafely(params)) }}</span>
    </div>

    <!-- オーダー種別 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'order_type'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <vs-chip
        class="pm-chip-square-radius pm-chip-width__order-type-disp"
        :color="
          getValueMapSafely(params).id === '1'
            ? '#5286ED'
            : getValueMapSafely(params).id === '2'
            ? '#A8309C'
            : getValueMapSafely(params).id === '3'
            ? '#34A118'
            : getValueMapSafely(params).id === '5'
            ? '#A8309C'
            : getValueMapSafely(params).id === '6'
            ? '#5286ED'
            : '#4F4F4F'
        "
      >
        <span>{{ getOrderTypeShortName(getValueMapSafely(params)) }}</span>
      </vs-chip>
    </div>

    <!-- オーダー時刻 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'order_at'"
      class="w-full flex items-center pm-ag-grid-inner-cell pm-time"
      :class="[classNameCursorPointer]"
    >
      <span v-if="formattedTime(getValueMapSafely(params))">{{
        formattedTime(getValueMapSafely(params))
      }}</span>
      <span v-else class="blank-circle-plus-left">
        +
      </span>
    </div>

    <!-- 綱ボート、車両、タグボート -->
    <div
      v-else-if="
        params.value &&
          ['rope_boats', 'vehicles', 'tug_boats'].includes(
            params.value.columnKey
          )
      "
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <!-- 件数表示の場合 is_count === true -->
      <div
        v-if="getValueMapSafely(params).is_count === true"
        class="w-full flex items-center pm-ag-grid-inner-cell"
      >
        <div
          v-if="getValueMapSafely(params).count"
          class="w-full flex items-center pm-ag-grid-inner-cell"
        >
          <div>{{ getValueMapSafely(params).count }}T</div>
        </div>
        <div v-else class="blank-circle-plus-left">
          +
        </div>
      </div>

      <!-- 件数表示の場合 is_size === true -->
      <div
        v-else-if="getValueMapSafely(params).is_size === true"
        class="w-full flex items-center pm-ag-grid-inner-cell"
      >
        <div
          v-if="
            getValueMapSafely(params).value.filter(x =>
              [2, 3].includes(x.status)
            ).length > 0
          "
          class="w-full flex items-center pm-ag-grid-inner-cell"
        >
          <vs-chip
            class="pm-chip-square-radius pm-chip-width__equipment"
            color="#346c88"
          >
            {{
              getValueMapSafely(params).value.filter(x =>
                [2, 3].includes(x.status)
              ).length
            }}T
          </vs-chip>
        </div>
        <div v-else class="blank-circle-plus-left">
          +
        </div>
      </div>

      <!-- 名称列挙の場合 -->
      <div v-else class="w-full flex items-center pm-ag-grid-inner-cell">
        <div
          v-if="
            getValueMapSafely(params).value.filter(x =>
              [2, 3].includes(x.status)
            ).length > 0
          "
          class="w-full flex items-center justify-start pm-ag-grid-inner-cell"
        >
          <div
            v-for="(equipment, index) in getValueMapSafely(params).value"
            :key="index"
            class="flex items-center pm-ag-grid-inner-cell"
          >
            <vs-chip
              class="pm-chip-square-radius pm-chip-width__equipment"
              v-if="[2, 3].includes(equipment.status)"
              :color="itemChipColor(equipment, params.value.columnKey)"
              :transparent="itemChipTransparent(equipment)"
              :style="itemChipStyle(equipment, params.value.columnKey)"
            >
              <span style="padding:0;margin:0;font-weight:bold;">
                {{
                  equipment.short_name ||
                    (equipment.name ? equipment.name.slice(0, 3) : null)
                }}
              </span>
            </vs-chip>
          </div>
        </div>
        <div v-else class="blank-circle-plus-left">
          +
        </div>
      </div>
    </div>

    <!-- 前泊地 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'previous'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
    >
      <span v-if="getValueMapSafely(params).order_type != 3">{{
        getValueMapSafely(params).port_name
      }}</span>
      <span
        v-else-if="getValueMapSafely(params).order_type == 3"
        :style="{
          'padding-left': '0.4rem',
          'border-left':
            getValueMapSafely(params).berth &&
            getValueMapSafely(params).berth.color
              ? '4px solid ' +
                '#' +
                getValueMapSafely(params).berth.color.color_hex
              : null,
        }"
      >
        {{
          getValueMapSafely(params).berth &&
            (getValueMapSafely(params).berth.label ||
              getValueMapSafely(params).berth.name)
        }}
      </span>
    </div>

    <!-- バース -->
    <div
      v-else-if="params.value && params.value.columnKey == 'berth'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <span
        v-if="getValueMapSafely(params).name"
        :style="{
          'padding-left': '0.4rem',
          'border-left': getValueMapSafely(params).color
            ? '4px solid ' + '#' + getValueMapSafely(params).color.color_hex
            : null,
        }"
      >
        {{ getValueMapSafely(params).label || getValueMapSafely(params).name }}
      </span>
      <span v-else class="blank-circle-plus-left">
        +
      </span>
    </div>

    <!-- 人数 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'head_count'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <div
        v-if="
          getValueMapSafely(params).value &&
            getValueMapSafely(params).value.length > 0
        "
      >
        <span
          v-for="(headCount, index) in getValueMapSafely(params).value"
          :key="index"
        >
          <span
            :style="{
              color: headCountColorCode(
                getValueMapSafely(params).color_id[index]
              ),
            }"
            class="pm-literal-margin"
            >{{ headCount }}</span
          >
        </span>
      </div>
      <div v-else class="blank-circle-plus-left">
        +
      </div>
    </div>

    <!-- 旗 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'flag'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <span v-if="getValueMapSafely(params).value" class="pm-flag">
        {{ getValueMapSafely(params).value }}
      </span>
      <span v-else class="blank-circle-plus-left">
        +
      </span>
    </div>

    <!-- ビット -->
    <div
      v-else-if="params.value && params.value.columnKey == 'bit'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <div
        v-if="getValueMapSafely(params).left || getValueMapSafely(params).right"
        class="w-full flex items-center pm-ag-grid-inner-cell"
      >
        <div
          class="vs-col flex items-center justify-start pm-ag-grid-inner-cell pm-chip-width__bit"
        >
          <span
            :style="{
              color:
                getValueMapSafely(params).left_options &&
                getValueMapSafely(params).left_options.required
                  ? '#D24C37'
                  : null,
            }"
            class="pm-literal-margin"
          >
            {{ getValueMapSafely(params).left }}
          </span>
        </div>
        <div
          class="vs-col flex items-center justify-center pm-ag-grid-inner-cell"
        >
          〜
        </div>
        <div
          class="vs-col flex items-center justify-start pm-ag-grid-inner-cell pm-chip-width__bit"
        >
          <span
            :style="{
              color:
                getValueMapSafely(params).right_options &&
                getValueMapSafely(params).right_options.required
                  ? '#D24C37'
                  : null,
            }"
            class="pm-literal-margin"
          >
            {{ getValueMapSafely(params).right }}
          </span>
        </div>
      </div>
      <div v-else class="blank-circle-plus-left">
        +
      </div>
    </div>

    <!-- 舷 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'boardside_type'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <div
        v-if="
          getValueMapSafely(params).id &&
            [1, 2, 3, 4, 5].includes(getValueMapSafely(params).id)
        "
        class="w-full flex items-center pm-ag-grid-inner-cell pm-chip-width__boardside"
      >
        {{
          getValueMapSafely(params).id === 1
            ? "左"
            : getValueMapSafely(params).id === 2
            ? "右"
            : getValueMapSafely(params).id === 3
            ? "左"
            : getValueMapSafely(params).id === 4
            ? "右"
            : getValueMapSafely(params).id === 5
            ? "？"
            : ""
        }}
        <feather-icon
          v-if="
            getValueMapSafely(params).id === 3 ||
              getValueMapSafely(params).id === 4
          "
          icon="RefreshCwIcon"
          svgClasses="h-4 w-4"
          class="pm-boardside-type-icon"
        />
      </div>
      <div v-else class="blank-circle-plus-left">
        +
      </div>
    </div>

    <!-- 水先案内人、班長 -->
    <div
      v-else-if="
        params.value &&
          ['pilot', 'team_leader'].includes(params.value.columnKey)
      "
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <div
        v-if="
          getValueMapSafely(params) &&
            [2, 3].includes(getValueMapSafely(params).status) &&
            (getValueMapSafely(params).short_name ||
              getValueMapSafely(params).name)
        "
        class="w-full flex items-center justify-center pm-ag-grid-inner-cell pm-chip-width__member"
      >
        <div
          class="flex justify-start pm-chip-square-radius pm-chip-width__member"
          :style="{
            color: itemChipColor(
              getValueMapSafely(params),
              params.value.columnKey,
              pilotColorFlg
            ),
          }"
        >
          {{
            getValueMapSafely(params) &&
              [2, 3].includes(getValueMapSafely(params).status) &&
              (getValueMapSafely(params).short_name ||
                (getValueMapSafely(params).name
                  ? getValueMapSafely(params).name.slice(0, 3)
                  : null))
          }}
        </div>
      </div>
      <div v-else class="blank-circle-plus-left">
        +
      </div>
    </div>

    <!-- 注意事項 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'caution_note'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <span
        v-if="
          getValueMapSafely(params).value &&
            getValueMapSafely(params).value.length > 0
        "
      >
        <feather-icon
          icon="AlertCircleIcon"
          svgClasses="h-6 w-6"
          class="mr-2"
        />
      </span>
    </div>

    <!-- 天候 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'weather'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <div
        class="flex items-center pm-ag-grid-inner-cell pm-chip-weather"
        v-if="getValueMapSafely(params).id"
      >
        <feather-icon
          v-if="getValueMapSafely(params).id === '1'"
          icon="WindIcon"
          svgClasses="h-5 w-5"
          class="mr-2"
        />
        <img
          v-if="getValueMapSafely(params).id === '2'"
          :src="rainWhiteIcon"
          class="mr-2 h-5 w-5"
        />
        <img
          v-if="getValueMapSafely(params).id === '3'"
          :src="snowWhiteIcon"
          class="mr-2 h-5 w-5"
        />
      </div>
      <div v-else class="blank-circle-plus-left">
        +
      </div>
    </div>

    <!-- 代理店 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'shipping_agency'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
    >
      <span class="pm-shipping-agency">{{
        getValueMapSafely(params).short_name ||
          (getValueMapSafely(params).name &&
            getValueMapSafely(params).name.slice(0, 3))
      }}</span>
    </div>

    <!-- 船舶 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'vessel'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <span>{{
        getValueMapSafely(params).order_type === "4"
          ? getValueMapSafely(params).task_name
          : getValueMapSafely(params).enterprisePortVessel &&
            (vesselNameJapaneseFlg
              ? getValueMapSafely(params).enterprisePortVessel.label ||
                getValueMapSafely(params).enterprisePortVessel.name
              : getValueMapSafely(params).enterprisePortVessel.name)
      }}</span>
    </div>

    <!-- グループハイライト -->
    <div
      v-else-if="params.value && params.value.columnKey == 'highlight'"
      class="w-full flex items-center justify-center pm-ag-grid-inner-cell"
    >
      <div
        @click="isSyncHighlight = !isSyncHighlight"
        class="highlight-toggle"
        :class="{
          'highlight-toggle--enabled': isSyncHighlight,
          'highlight-toggle--disabled': !isSyncHighlight,
        }"
      ></div>
    </div>

    <!-- 備考 -->
    <div
      v-else-if="params.value && params.value.columnKey == 'required_note'"
      class="w-full flex items-center pm-ag-grid-inner-cell"
      :class="[classNameCursorPointer]"
    >
      <div 
        class="flex items-center pm-ag-grid-inner-cell"
        v-if="getInputValue"
      >
      {{getValueMapSafely(params).value}}</div>
      <div v-else class="flex items-center pm-ag-grid-inner-cell">
        -
      </div>
    </div>


    <div v-else class="w-full flex items-center pm-ag-grid-inner-cell">
      <span>{{ getInputValue }}</span>
    </div>

    <div is="style">
      .ag-theme-material .ag-icon-grip:before { display: inline-block; width:
      1.4rem; height: 1.4rem; margin: 0 0 0 10px !important; padding: 0
      !important; vertical-align: top; content : ' '; font-size: 1.8rem;
      background-image: url({{ rowDragIconUrl }}); background-repeat: no-repeat;
      background-size: contain; }
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "portMasterDestinationWork"
);
const { mapState: mapStateOfPortMaster } = createNamespacedHelpers(
  "portMaster"
);
import moment from "moment-timezone";

export default {
  name: "CellRendererItem",
  components: {},
  data() {
    return {
      updateBLinkMinutes: 0, // 変更直後の点滅の時間（分）。 0=点滅なし。
      nowValueOf: moment().valueOf(),
      isHighlight: false,
      isReadOnlyDevice: false,
      orderTypeShortNameMap: {
        "1": "入",
        "2": "出",
        "3": "シ",
        "4": "他",
        "5": "出早",
        "6": "着",
      },
      rowDragIconUrl: require("@/assets/images/icons/port-master/row_drag.svg"),
      snowWhiteIcon: require(`@/assets/images/icons/port-master/snow_white.svg`),
      rainWhiteIcon: require(`@/assets/images/icons/port-master/rain_white.svg`),
    };
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      destinationWorkHeaders: state => state.destinationWorkHeaders,
      vesselNameJapaneseFlg: state => state.vesselNameJapaneseFlg,
      pilotColorFlg: state => state.pilotColorFlg,
      selectedTaskId: state => state.selectedTaskId,
      selectedColumnKey: state => state.selectedColumnKey,
      summaryDialogShowPopup: state => state.summaryDialogShowPopup,
    }),
    ...mapStateOfPortMaster({
      selectedPort: state => state.selectedPort,
    }),
    getInputValue() {
      let valueMap = this.getValueMapSafely(this.params);
      if (Array.isArray(valueMap)) {
        return valueMap;
      } else {
        return (
          this.getValueMapSafely(this.params).name ||
          this.getValueMapSafely(this.params).value ||
          this.getValueMapSafely(this.params).id
        );
      }
    },
    getValueMapSafely() {
      return params => {
        if (params && params.value && params.value.valueMap) {
          return params.value.valueMap;
        } else {
          return {};
        }
      };
    },
    getUpdateColor() {
      const self = this;
      return function(changesValue) {
        if (changesValue && self.nowValueOf) {
          // changesValueが存在した時点で、style適用は確定
          const elapsedMinutes = (self.nowValueOf - changesValue) / 1000 / 60;
          if (elapsedMinutes < self.updateBlinkMinutes) {
            // x分以内だったら。Blink
            return "updated-cell-blink";
          }
          return "updated-cell";
        }
        return null;
      };
    },
    getSelectedColor() {
      const selfTaskId =
        this.params &&
        this.params &&
        this.params.value &&
        this.params.value.taskId
          ? this.params.value.taskId
          : "";
      const selfColumnKey =
        this.params &&
        this.params &&
        this.params.value &&
        this.params.value.columnKey
          ? this.params.value.columnKey
          : "";

      if (
        this.summaryDialogShowPopup === true &&
        selfTaskId === this.selectedTaskId
      ) {
        if (
          selfColumnKey === this.selectedColumnKey &&
          !["highlight", "vessel", "caution_note"].includes(selfColumnKey)
        ) {
          return "pm-selected-cell";
        }
        return "pm-selected-row";
      }
      return null;
    },
    classNameCursorPointer() {
      const displayId = this.$route.params.displayId;
      if (["2", "3"].includes(displayId)) {
        return null;
      }
      if (this.isReadOnlyDevice === true) {
        return null;
      }
      return "pm-cursor-pointer";
    },

    cellBackgroundColor() {
      const updateColor =
        this.params &&
        this.params.value &&
        this.getUpdateColor(this.params.value.changes);
      const selectedColor = this.getSelectedColor;
      if (selectedColor === "pm-selected-cell") {
        return selectedColor;
      } else if (selectedColor === "pm-selected-row") {
        return selectedColor;
      } else if (updateColor) {
        return updateColor;
      } else if (this.isSyncHighlight === true) {
        return "pm-grouped-row";
      }
      return null;
    },

    isSyncHighlight: {
      get() {
        return (
          this.params && this.params.value && this.params.value.highlight === 1
        );
      },
      async set(val) {
        const highlightValue = val === true ? 1 : 0;

        // 同一行の別の列項目に highlight情報を伝搬。

        for (let key of Object.keys(this.params.node.data)) {
          if (!["id", "docData"].includes(key)) {
            this.params.node.data[key].highlight = highlightValue;
          }
        }

        let updateData = {
          enterprisePort: this.selectedPort,
          taskId: this.params.value.taskId,
          data: {
            highlight: highlightValue,
          },
        };
        // firestoreを更新
        this.updateFirestoreDocument(updateData);

        // agGrid1の対象行に直接更新。
        const newTaskWithName = await this.mergeUpdateDataIntoTaskRecord(
          updateData
        );
        this.params.node.setData(newTaskWithName);
      },
    },
  },
  methods: {
    ...mapActions(["updateFirestoreDocument", "mergeUpdateDataIntoTaskRecord"]),
    formattedTime(dateValue) {
      if (!dateValue || !dateValue.value) {
        return "";
      }
      return moment(dateValue.value)
        .local()
        .format("HH:mm");
    },
    formattedTimeForProgress(dateValue) {
      if (
        !dateValue ||
        !dateValue.value ||
        !dateValue.progress ||
        !dateValue.value[dateValue.progress]
      ) {
        return "";
      }
      return moment(dateValue.value[dateValue.progress].seconds * 1000)
        .local()
        .format("HH:mm");
    },
    getOrderTypeShortName(valueMap) {
      const shortName = this.orderTypeShortNameMap[valueMap.id];
      if (shortName) {
        return shortName;
      } else {
        return valueMap.value ? valueMap.value.slice(0, 1) : "";
      }
    },
    bitColorCode(colorId) {
      let colorObj = this.masterMap["bit_colors"].find(
        color => color.id === colorId
      );
      return colorObj ? colorObj.value : null;
    },
    headCountColorCode(colorId) {
      let colorObj = this.masterMap["head_count_colors"].find(
        color => color.id === colorId
      );
      return colorObj ? colorObj.value : null;
    },
    progressColorCode(colorId) {
      let colorObj = this.masterMap["progress_colors"].find(
        color => color.id === colorId
      );
      return colorObj ? colorObj.value : null;
    },
    itemChipColor(unit, columnKey, pilotColorFlg) {
      let itemColorCode = null;
      if (columnKey === "pilot" || columnKey === "team_leader") {
        if (pilotColorFlg && unit.color && unit.color.color_hex) {
          itemColorCode = "#" + unit.color.color_hex;
        } else {
          itemColorCode = null;
        }
      } else {
        if (unit.status === 2) {
          itemColorCode = "#081e29";
        } else if (unit.status === 3) {
          const borderColor =
            columnKey === "vehicles"
              ? "#20678F"
              : columnKey === "rope_boats"
              ? "#34A118"
              : "#346c88";
          itemColorCode = borderColor;
        }
      }
      return itemColorCode;
    },
    itemChipTransparent(unit, columnKey, pilotColorFlg) {
      let isTransparent = false;
      if (columnKey === "pilot" && pilotColorFlg) {
        isTransparent = false;
      } else if (unit.status === 2) {
        isTransparent = true;
      }
      return isTransparent;
    },
    itemChipStyle(unit, columnKey) {
      const isTransparent = this.itemChipTransparent(unit, columnKey);
      const borderColor =
        columnKey === "vehicles"
          ? "#20678F"
          : columnKey === "rope_boats"
          ? "#34A118"
          : "#346c88";

      return {
        border: "0.1rem solid " + borderColor,
        "box-sizing": "border-box",
        "background-color": (isTransparent ? "#c4c4c4" : null) + " !important",
      };
    },
    detectReadOnlyDevice() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (
        userAgent.indexOf("ipad") > -1 ||
        (userAgent.indexOf("macintosh") > -1 && "ontouchend" in document)
      ) {
        // iPadの場合
        this.isReadOnlyDevice = true;
      }
    },
  },
  mounted() {
    setInterval(() => {
      this.nowValueOf = moment().valueOf();
    }, 10 * 60 * 1000);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";

.pm-ag-grid-inner-cell {
  height: 100%;
  padding: 0 auto;
}

.con-vs-chip {
  margin-top: 0.2rem;
  min-height: 80%; // vs-chipの高さ指定1
  max-height: 80%; // vs-chipの高さ指定2
}
// .blank-circle-plus {
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
.blank-circle-plus-left {
  display: flex;
  margin-left: 0.1rem;
  align-items: center;
  font-size: 80%;
}

// .blank-circle-plus-icon {
//   color: $pm-blue;
// }

.cell-renderer-item {
  height: 2rem;
  padding-left: 0.2rem;
}
.updated-cell {
  background-color: #768227;
  border: none;
}
.updated-cell-blink {
  animation: blinkAnime 2s infinite alternate;
  border: 1px solid #768227;
}
@keyframes blinkAnime {
  0% {
    background-color: rgba(226, 229, 108, 0.8);
  }
  100% {
    background-color: rgba(226, 229, 108, 0.2);
  }
}

.pm-grouped-row {
  background-color: #65676a;
}
.pm-selected-row {
  background-color: $pm-gray;
}
.pm-selected-cell {
  background-color: #333333;
  border: 0.15rem solid $pm-blue;
  box-sizing: border-box;
}

.pm-literal-margin {
  margin: 0 0.1rem;
}
.pm-chip-square-radius {
  border-radius: 0.2rem;
}
.pm-chip-circle-radius {
  border-radius: 1rem;
}

.pm-chip-width {
  &__equipment {
    min-width: 1.8rem;
    width: 1.8rem;
  }
  &__member {
    width: 4rem;
  }
  &__progress-type-disp {
    width: 3.8rem;
  }
  &__order-type-disp {
    width: 2rem;
  }
  &__bit {
    width: 3.8rem;
  }
  &__boardside {
    width: 3.2rem;
    padding-right: 0.2rem;
  }
  &__weather {
    width: 2rem;
  }
}
.pm-time {
  font-size: 110%;
}
.pm-chip-weather {
  border-radius: 1rem;
  padding-top: 0;
  padding-left: 0;
}

.pm-boardside-type-icon {
  padding-left: 0.4rem;
}

.pm-shipping-agency {
  padding-left: 0.2rem;
}
.pm-flag {
  padding-left: 0.2rem;
}

// .pm-plus-padding {
//   padding-left:0.4rem;
//   padding-right:0.6rem;
// }

// .pm-plus-left {
//   width: 100%;
//   padding-left: 1rem;
//   padding-right: 100%;
// }

.pm-cursor-pointer {
  cursor: pointer;
}

.highlight-toggle {
  $cell_mergin: calc(0.1rem);
  $slider_width: calc(1.4rem);
  $slider_height: calc(#{$slider_width} / 2);
  $cell_size: calc(#{$slider_height} - #{$cell_mergin} * 2);

  cursor: pointer;
  width: $slider_width;
  height: $slider_height;
  border-radius: calc(#{$slider_height} / 2);

  &:before {
    content: "";
    position: absolute;
    top: calc(50% - #{$cell_mergin} - #{$cell_size} / 2);
    height: $cell_size;
    width: $cell_size;
    border-radius: 50%;
    margin: $cell_mergin;
  }

  &--enabled {
    background-color: #959596;
    &:before {
      margin-left: calc(#{$slider_width} - #{$cell_mergin} - #{$cell_size});
      background-color: $pm-white;
    }
  }

  &--disabled {
    background-color: #727272;
    &:before {
      background-color: $pm-mouse-gray;
    }
  }
}
</style>
